import axios from 'axios';

const TOKEN_KEY = 'arq_token';
// Fallback é URL pública (NUNCA localhost/IP local). Padrão Centrão.
const API_URL = process.env.REACT_APP_API_URL || 'https://api-arquitetos.centraomateriais.com';

const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem(TOKEN_KEY);
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
